import { HStack, Link } from '@bpba/ui-components';
import { FOOTER_DATA } from '../../constants/data';
import { SelloData } from '../../model/SelloData';
import { Sello } from './Sello';

export const Sellos1 = () => {
  return <Sello data={arrepentimientoData} width="100%" display={['flex', 'unset']} justifyContent={['center', 'unset']} />;
};

export const Sellos2 = () => {
  return (
    <HStack width={'100%'} justifyContent={['center', 'unset']} marginTop={['24px', null, null, '0px']}>
      <Sello data={adhesion} marginRight={['16px', '0px']} />
      <Sello data={bcra} />
    </HStack>
  );
};

const arrepentimientoData = new SelloData(
  0,
  new Link(
    FOOTER_DATA.arrepentimiento.enlace.ruta,
    FOOTER_DATA.arrepentimiento.enlace.isExterno,
    FOOTER_DATA.arrepentimiento.enlace.abreSolapa
  ),
  undefined,
  FOOTER_DATA.arrepentimiento.imageUrl,
  FOOTER_DATA.arrepentimiento.textoAlternativo
);

const adhesion = new SelloData(
  1,
  new Link(FOOTER_DATA.adhesion.enlace.ruta, FOOTER_DATA.adhesion.enlace.isExterno, FOOTER_DATA.adhesion.enlace.abreSolapa),
  undefined,
  FOOTER_DATA.adhesion.imageUrl,
  FOOTER_DATA.adhesion.textoAlternativo
);

const bcra = new SelloData(
  2,
  new Link(FOOTER_DATA.BCRA.enlace.ruta, FOOTER_DATA.BCRA.enlace.isExterno, FOOTER_DATA.BCRA.enlace.abreSolapa),
  undefined,
  FOOTER_DATA.BCRA.imageUrl,
  FOOTER_DATA.BCRA.textoAlternativo
);
